import React from 'react';
import Services from './subcomponents/Services';

const ServicesList = () => {
    return(
        <div className="container-fluid" id="services-list">
            <Services />
        </div>
    );
}

export default ServicesList;